import React, { Component } from 'react';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Pagination extends Component {

    shouldComponentUpdate(nextProps, nextState) {
        return !_.isEqual(nextProps, this.props);
    }

    render() {
        const { currentPage, totalPage, setPage, hasMore } = this.props;
        if (totalPage) {
            if (totalPage === 1) {
                return (<div className="pagination"></div>);
            }
            return (
                <div className="pagination">
                    <ul>
                        {currentPage > 1 && <li onClick={() => setPage(1)}><FontAwesomeIcon icon={["fal", "chevron-double-left"]} /></li>}
                        {currentPage > 1 && <li onClick={() => setPage(currentPage - 1)}><FontAwesomeIcon icon={["fal", "chevron-left"]} /></li>}
                        {currentPage - 1 >= 1 && <li onClick={() => setPage(currentPage - 1)}>{currentPage - 1}</li>}
                        <li className="active">{currentPage}</li>
                        {totalPage >= currentPage + 1 && <li onClick={() => setPage(currentPage + 1)}>{currentPage + 1}</li>}
                        {totalPage >= currentPage + 2 && <li onClick={() => setPage(currentPage + 2)}>{currentPage + 2}</li>}
                        {currentPage < totalPage && <li onClick={() => setPage(currentPage + 1)}><FontAwesomeIcon icon={["fal", "chevron-right"]} /></li>}
                        {currentPage < totalPage && <li onClick={() => setPage(totalPage)}><FontAwesomeIcon icon={["fal", "chevron-double-right"]} /></li>}
                    </ul>
                </div>
            );
        } else {
            if (currentPage === 1 && !hasMore) {
                return (<div className="pagination"></div>);
            }
            return (
                <div className="pagination">
                    <ul>
                        {currentPage > 1 && <li onClick={() => setPage(1)}><FontAwesomeIcon icon={["fal", "chevron-double-left"]} /></li>}
                        {currentPage > 1 && <li onClick={() => setPage(currentPage - 1)}><FontAwesomeIcon icon={["fal", "chevron-left"]} /></li>}
                        {currentPage - 1 >= 1 && <li onClick={() => setPage(currentPage - 1)}>{currentPage - 1}</li>}
                        <li className="active">{currentPage}</li>
                        {hasMore && <li onClick={() => setPage(currentPage + 1)}>{currentPage + 1}</li>}
                        {/* {totalPage >= currentPage + 2 && <li onClick={() => setPage(currentPage + 2)}>{currentPage + 2}</li>} */}
                        {hasMore && <li onClick={() => setPage(currentPage + 1)}><FontAwesomeIcon icon={["fal", "chevron-right"]} /></li>}
                        {/* {currentPage < totalPage && <li onClick={() => setPage(totalPage)}><FontAwesomeIcon icon={["fal", "chevron-double-right"]}/></li>} */}
                    </ul>
                </div>
            );
        }
    }
}

export default Pagination